import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { AccountingSettingsFormValues } from "../schemas/accountingSettingsForm"

import { FormNumericField } from "@/components/UiKit"

const HELPER_TEXT =
  "Invoices will be sent to Huntington Bank to disburse funds XX business days prior to the Invoice Due Date."

export const AccountingSettingsForm: FC = () => {
  const { control } = useFormContext<AccountingSettingsFormValues>()

  return (
    <Box className='rounded-md border border-solid border-gray-400 p-6'>
      <Typography variant='h6' className='mb-6 text-gray-900'>
        Payables
      </Typography>
      <Box className='grid grid-cols-3 gap-6'>
        <FormNumericField
          control={control}
          name='paymentByAchOrVirtualCcLeadDays'
          label='Payment by ACH or Virtual Credit Card'
          required
          decimalScale={0}
          allowNegative={false}
          allowLeadingZeros={false}
          thousandSeparator={false}
          data-testid='accounting-settings.form.payment-ach-field'
        />
        <FormNumericField
          control={control}
          name='paymentByCheckLeadDays'
          label='Payment by Check'
          required
          decimalScale={0}
          allowNegative={false}
          allowLeadingZeros={false}
          thousandSeparator={false}
          data-testid='accounting-settings.form.payment-check-field'
        />
        <FormNumericField
          control={control}
          name='paymentByWireLeadDays'
          label='Payment by Wire'
          required
          decimalScale={0}
          allowNegative={false}
          allowLeadingZeros={false}
          thousandSeparator={false}
          data-testid='accounting-settings.form.payment-wire-field'
        />
      </Box>
      <Typography variant='body2' className='mt-4 text-gray-700' data-testid='accounting-settings.form.helper-text'>
        {HELPER_TEXT}
      </Typography>
    </Box>
  )
}
